const FLOAT_REGEX = /^[+-]?\d*\.\d+$/;

export const isFloat = (value: string): boolean => FLOAT_REGEX.test(value);

const INTEGER_REGEX = /^[+-]?\d+$/;

export const isInteger = (value: string): boolean => INTEGER_REGEX.test(value);
